export enum TitlePosition {
  Top = "Top",
  Right = "Right",
  Bottom = "Bottom",
  Left = "Left"
}
